import * as React from 'react'
import classNames from 'classnames'
import { IRiderObject, IStateMetadata } from '../../../types'
import UIMessages from '../../../utils/ui-messages'
import { CardElement, injectStripe } from 'react-stripe-elements'
import { withNotification } from '../../ui/notification-provider'
import { setTimeout } from 'timers'
import { Button, Input } from '@mobiscroll/react-latest'

interface ICardFormProps {
  stripe: any
  metadata: IStateMetadata
  rider: IRiderObject
  onCancel?: () => void
  notification?: any
  addRiderPaymentSource: (stripeToken: string, riderId: string) => Promise<any>
}

interface ICardFormState {
  nameOnCard: string
  saving: boolean
  error: string
  cardSaved: boolean
}

class AddCardForm extends React.Component<ICardFormProps, ICardFormState> {
  private cardFormElm: any

  constructor(props: ICardFormProps) {
    super(props)
    this.state = {
      nameOnCard: '',
      saving: false,
      error: '',
      cardSaved: false
    }
  }

  public componentDidMount() {
    this.setState({
      nameOnCard: `${this.props.rider.firstName} ${this.props.rider.lastName}`
    })
  }

  public render() {
    // if (this.state.cardSaved) {
    //   return <div onAnimationEnd={this.cardSavedSuccess}>card saved</div>
    // }
    return (
      <div style={{ flex: 1 }}>
        <div
          className={classNames('bg0 mt3', {
            mb2: !!this.props.onCancel,
            mr4: !this.props.onCancel
          })}
        >
          <div className='flex mt1'>
            <Input
              type='text'
              className='mobiscroll-input form w100'
              onChange={this.onNameChange}
              value={this.state.nameOnCard}
              theme='ios'
              themeVariant='light'
              inputStyle='box'
              label={'Name on Card'}
              labelStyle='floating'
            />
          </div>
          <div className='flex mt2'>
            <div className='card-number-input'>
              <CardElement ref={this.setElmRef} />
            </div>
          </div>
          <div className='flex mt2 justify-right'>
            <Button
              ariaLabel='addPaymentMethod'
              onClick={this.onAddPayment}
              disabled={this.state.saving}
              className={'mbsc-green-btn mr2'}
            >
              {UIMessages.common.addPaymentMethod}
            </Button>
            {this.props.onCancel && (
              <Button ariaLabel='cancel' type='button' onClick={this.props.onCancel} className='mbsc-clear-btn'>
                {UIMessages.common.cancel}
              </Button>
            )}
          </div>
        </div>
      </div>
    )
  }
  private cardSavedSuccess() {
    setTimeout(() => {
      this.setState({
        cardSaved: false
      })
    }, 100)
  }
  //TODO these kind of flows work better with async/await. Need to
  //figure out the webpack config for that
  private onAddPayment = () => {
    this.setState({ saving: true })
    return this.props.stripe
      .createToken({ name: this.state.nameOnCard })
      .then(({ token }: any) => {
        //TODO: investigate why this line does not work when funds are added from trip detail pane
        // this.props.notification.addNotification({ //date Written July 19,,2021. Causes error: this.props.notification. addNotification is not a function.
        //   title: 'Success',
        //   message: 'Card has been added successfully.',
        //   level: 'success',
        //   autoDismiss: 10
        // })
        // this.setState({ saving: false, error: '', nameOnCard: '' }, () => {
        //   this.cardFormElm._element.clear()
        // })
        // this.setState({
        //   cardSaved: true
        // })
        this.props.addRiderPaymentSource(token.id, this.props.rider.id).then(() => {
          this.setState({ saving: false, error: '', nameOnCard: '' }, () => {
            this.cardFormElm._element.clear()
          })
          if (this.props.onCancel) {
            this.props.onCancel()
          }
        })
      })
      .catch((err: any) => {
        this.setState({
          saving: false,
          error: 'There was a problem saving your payment method'
        })
      })
  }
  private onNameChange = (e: any) => {
    this.setState({ nameOnCard: e.target.value })
  }
  private setElmRef = (ref: any) => {
    this.cardFormElm = ref
  }
}

export default withNotification(injectStripe(AddCardForm))



// WEBPACK FOOTER //
// ./src/components/riders/common/AddCardForm.tsx